/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { darken } from 'polished';

export default $ => css`
  html body {
    font-family: ${$.fontFamily};
    font-optical-sizing: auto;
    font-weight: 300;
    font-style: normal;
    font-size: 15px;
  }

  html,
  body,
  #app-root,
  .app-layout {
    width: 100%;
    height: 100vh;
  }

  .app-layout-internal {
    margin-top: ${$.navbarHeight};
    height: calc(100% - ${$.navbarHeight});
    min-height: 0;
  }

  body {
    background-color: ${$.gray100} !important;
  }

  a.nav-link {
    cursor: pointer;
  }

  .dont-show-component {
    display: none;
  }

  legend {
    font-weight: bold;
    font-size: 1.75rem;
  }

  a {
    color: ${$.infoMain};
  }

  .field-description {
    // font-weight: bold;
    // font-size: 1.4rem;
    // font-style: italic;
  }

  .control-label {
    font-weight: bold;
    margin-bottom: 1rem;

    & > .required {
      color: ${$.dangerMain};
    }
  }

  input[type='radio'] {
    margin-right: 0.75rem;
  }

  #root__title {
    margin-bottom: 1.25rem;
    font-weight: bold;
  }

  .form-title {
    text-align: center;
    margin-bottom: 2rem;
  }

  .step-circle {
    background: ${$.primaryMain};
    margin: 0px auto 0.5rem auto;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .centered-component {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .step-title {
    color: ${$.primaryMain};
    opacity: 0.5;

    &.active {
      opacity: 1;
      font-weight: 700;
    }
  }

  .field-radio-group {
    display: flex;
    flex-wrap: wrap;

    .radio {
      margin-right: 1rem;
    }

    .radio-inline {
      margin-right: 1rem;
    }
  }

  input[type='checkbox'] {
    margin-right: 8px;
    accent-color: ${$.primaryMain};
  }

  .card.clickable:hover {
    background: ${$.gray100};
    cursor: pointer;
  }

  .sort-button {
    white-space: nowrap;
  }

  .form-submit-buttons > :not(:first-of-type) {
    margin-left: 45px;
  }

  div.is-a-p {
    margin-bottom: 1rem;
  }

  nav > .collapse > ul.navbar-nav:not(:last-child),
  nav > .collapsing > ul.navbar-nav:not(:last-child) {
    flex-grow: 1;
  }

  .nowrap {
    white-space: nowrap;
  }

  .banner-heading {
    background-color: ${$.secondaryMain};
    color: ${$.white};
    box-sizing: content-box;
  }

  .no-margin {
    margin: 0 !important;
  }

  .btn-submit {
    background-color: ${$.primaryMain};
    color: ${$.white};

    &:hover {
      background-color: ${darken(0.075, $.primaryMain)};
    }

    &:focus {
      background-color: ${darken(0.1, $.primaryMain)};
    }
  }

  .btn-save {
    background-color: ${$.successMain};
    color: ${$.white};

    &:hover {
      background-color: ${darken(0.075, $.successMain)};
    }

    &:focus {
      background-color: ${darken(0.1, $.successMain)};
    }
  }
`;
